import { useMemo } from 'react'

import { Feature } from '@jotta/grpc-connect-openapi/feature'
import { FeatureToggle } from '@jotta/types/FeatureToggle'

import { useGetConfig } from './useGetConfig'

export function useFeatures() {
  const { data, isPending } = useGetConfig()
  const features = data?.activeFeatures || []
  const featureToggles = data?.activeFeatureToggleIds || []

  return useMemo(
    () => ({
      isPending,
      signup: features.includes(Feature.SIGNUP),
      presignup: features.includes(Feature.PRE_SIGNUP),
      newsletter: features.includes(Feature.NEWSLETTER),
      stripe: features.includes(Feature.STRIPE),
      cli: features.includes(Feature.CLI),
      photoSearch: featureToggles.includes(FeatureToggle.PhotoSearch),
      vipps: features.includes(Feature.VIPPS),
      twoFactor: features.includes(Feature.TWO_FACTOR),
      wopiTestMode: featureToggles.includes(FeatureToggle.WopiTestMode),
      timelineV2: featureToggles.includes(FeatureToggle.TimelineV2),
      people: featureToggles.includes(FeatureToggle.People),
      facesV2: featureToggles.includes(FeatureToggle.FacesV2),
      photoEditorEnabled: featureToggles.includes(FeatureToggle.PhotoEditor),
      photoEditorInFilesEnabled: featureToggles.includes(
        FeatureToggle.PhotoEditorInFiles,
      ),
      referralsEnabled: featureToggles.includes(FeatureToggle.Referrals),
      inAppBrowserBreakoutEnabled: featureToggles.includes(
        FeatureToggle.InAppBrowserBreakout,
      ),
      inAppBrowserBreakoutIOSEnabled: featureToggles.includes(
        FeatureToggle.InAppBrowserBreakoutIOS,
      ),
      inAppBrowserBreakoutAndroidEnabled: featureToggles.includes(
        FeatureToggle.InAppBrowserBreakoutAndroid,
      ),
    }),
    [isPending, features, featureToggles],
  )
}
